import { Button, Form } from 'react-bulma-components';
import { MODAL_TYPES, useGlobalModalContext } from "../hooks/globalModal";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

const { Textarea } = Form;

// REPLACED BY MarkdownTextareaAC
const MarkdownTextarea = forwardRef(({ name, placeholder, value, onChange, pageSlug }, ref) => {
  //pageSlug = "all";  // TODO remove
  const { showModal, hideModal } = useGlobalModalContext();
  const areaRef = useRef(null);
  useImperativeHandle(ref, () => ({
    getAreaRef() {
      return areaRef;
    }
  }));

  function onImagePropsFromModal({path, bg})
  {
    hideModal();
    const snippet = `<image src='${path}' bg='${bg===true?'o':''}'></image>`;
    pasteTemplate(null, snippet, snippet.length-8);
  }
  const createModal = () => {
    showModal(MODAL_TYPES.MEDIA_MODAL, {
      title: `Files for /${pageSlug}`,
      path: `/${pageSlug}`,
      confirmBtn: "Save",
      returnImageProps: onImagePropsFromModal,
      createModalFunction: createModal
    });
  };
  function pasteTemplate(type, template, offset) {
    const ta = areaRef.current;
    let selection = ta.value.substring(ta.selectionStart, ta.selectionEnd);
    let snippet = "";
    offset = offset || 0;
    switch (type) {
      case 'ch':
        snippet = `<ch>${selection}</ch>`;
        offset = 4;
        break;
      case 'instrument':
        snippet = `<instrument>\n\t<C>${selection}</C>\n\t<Bb></Bb>\n\t<Eb></Eb>\n</instrument>`;
        offset = 17;
        break;
      case 'sc':
        snippet = `<sc>${selection}</sc>`;
        offset = 4;
        break;
      case 'score':
        snippet = `<score >${selection}</score>`;
        offset = 8;
        break;
      case 't':
        snippet = `<t>${selection}</t>`;
        offset = 3;
        break;
      case 'x':
      snippet = `<x>${selection}</x>`;
      offset = 3;
      break;
      default:
        snippet = template;
        offset =  offset;
    }
    //value= snippet; 
    offset += selection.length;
    ta.setRangeText(snippet)
    ta.selectionStart = ta.selectionEnd = ta.selectionStart + offset; //Math.floor(snippet.length / 2);

    const event = new Event("input", { bubbles: true });
    ta.dispatchEvent(event);

    ta.focus();
    //areaRef.current.onClick();
  }

  return (
    <>
      <Button.Group hasAddons={true} size='small' marginless={true} >
        <Button
          color=""
          renderAs="span"
          marginless={true}
          onClick={() => pasteTemplate('ch')}
          
        >
          <b>&lt;ch/&gt;</b>
        </Button>
        <Button
          color=""
          renderAs="span"
          marginless={true}
          onClick={() => pasteTemplate('instrument')}
        >
          <b>&lt;instrument/&gt;</b>
        </Button>
        <Button
          color=""
          renderAs="span"
          marginless={true}
          onClick={() => pasteTemplate('sc')}
        >
          <b>&lt;sc/&gt;</b>
        </Button>
        <Button
          color=""
          renderAs="span"
          marginless={true}
          onClick={() => pasteTemplate('score')}
        >
          <b>&lt;score/&gt;</b>
        </Button>
        <Button
          color=""
          renderAs="span"
          marginless={true}
          onClick={() => pasteTemplate('t')}
        >
          <b>&lt;t/&gt;</b>
        </Button>
        <Button
          ml={2}
          color="warning"
          renderAs="span"
          marginless={true}
          onClick={() => createModal()}
        >
          <b>Open files</b>
        </Button>
      </Button.Group>
      <Textarea domRef={areaRef} name={name} placeholder={placeholder} value={value} onChange={onChange} />
    </>
  );
})

export default MarkdownTextarea;